"use client";
import React from 'react';
import Link from 'next/link';
import styles from './BlogNavigation.module.css';
import { useTranslation } from 'react-i18next';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const BreadcrumbNavigation = ({ 
  items = [],  
  currentPageTitle = ""
}) => {
  const { t } = useTranslation();
  
  // Function to truncate long breadcrumb items for smaller screens
  const getTruncatedTitle = (title, maxLength = 15) => {
    if (title.length <= maxLength) return title;
    return `${title.substring(0, maxLength)}...`;
  };

  return (
    <div className={styles.breadcrumbContainer}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <Link href={item.path} className={styles.breadcrumbLink}>
            <span className={styles.breadcrumbText}>{t(item.title)}</span>
          </Link>
          <ArrowForwardIosIcon className={styles.arrow} sx={{ fontSize: 13 }} />
        </React.Fragment>
      ))}
      <span className={styles.currentPage} title={t(currentPageTitle)}>{t(currentPageTitle)}</span>
    </div>
  );
};

export default BreadcrumbNavigation; 